export { default as EmbeddedForeignContentBanner } from './EmbeddedForeignContentBanner';
